import React from 'react';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';
import PropTypes from 'prop-types';

const RegistrationContext = React.createContext();

const name = 'registrationDataStore';

export const useRegistration = () => React.useContext(RegistrationContext);

export const connectToRegistration = makeConnectTo(RegistrationContext, name);

export default class RegistrationDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
		isMobile: PropTypes.func,
	};

	state = {
		isLoading: true,
		countries: {},
	};

	render() {
		const registrationDataStore = this.getStore();
		return (
			<RegistrationContext.Provider value={registrationDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(registrationDataStore)
					: this.props.children}
			</RegistrationContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchCountries();
	}

	componentWillUnmount() {
		if (this.countriesFetch && this.countriesFetch.cancel) {
			this.countriesFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refreshCountries: () => this.fetchCountries(),
	});

	refreshCountries = () => {
		this.setState({
			isLoading: true,
		});
		this.fetchCountries();
		return this.countriesFetch.promise;
	};

	fetchCountries = () => {
		const request = api.cancelableGet(`/api/v1/registration/countries`);
		request.promise.then(this.cacheFetchCountries);
		this.countriesFetch = request;
	};

	cacheFetchCountries = countries => {
		this.setState({ countries, isLoading: false });
	};
}
